export const foundationItems = [
  {
    title: 'Save the Children',
    url: 'https://www.savethechildren.net/what-we-do/emergencies/ukraine-crisis',
    img1x: new URL(
      '../../images/support-ukraine/save-children@1x.png',
      import.meta.url
    ),
    img2x: new URL(
      '../../images/support-ukraine/save-children@2x.png',
      import.meta.url
    ),
  },
  {
    title: 'Project HOPE',
    url: 'https://www.projecthope.org/country/ukraine/',
    img1x: new URL('../../images/support-ukraine/hope@1x.png', import.meta.url),
    img2x: new URL('../../images/support-ukraine/hope@2x.png', import.meta.url),
  },

  {
    title: 'UNITED24',
    url: 'https://u24.gov.ua/uk',
    img1x: new URL(
      '../../images/support-ukraine/united24@1x.png',
      import.meta.url
    ),
    img2x: new URL(
      '../../images/support-ukraine/united24@2x.png',
      import.meta.url
    ),
  },
  {
    title: 'International Medical Corps',
    url: 'https://internationalmedicalcorps.org/country/ukraine/',
    img1x: new URL(
      '../../images/support-ukraine/international-med@1x.png',
      import.meta.url
    ),
    img2x: new URL(
      '../../images/support-ukraine/international-med@2x.png',
      import.meta.url
    ),
  },
  {
    title: 'Medicins Sans Frontieres',
    url: 'https://www.msf.org/ukraine',
    img1x: new URL(
      '../../images/support-ukraine/med-sans@1x.png',
      import.meta.url
    ),
    img2x: new URL(
      '../../images/support-ukraine/med-sans@2x.png',
      import.meta.url
    ),
  },
  {
    title: 'RAZOM',
    url: 'https://www.razomforukraine.org/',
    img1x: new URL(
      '../../images/support-ukraine/razom@1x.png',
      import.meta.url
    ),
    img2x: new URL(
      '../../images/support-ukraine/razom@2x.png',
      import.meta.url
    ),
  },
  {
    title: 'Action against hunger',
    url: 'https://www.actionagainsthunger.org/location/europe/ukraine/',
    img1x: new URL(
      '../../images/support-ukraine/action-against@1x.png',
      import.meta.url
    ),
    img2x: new URL(
      '../../images/support-ukraine/action-against@2x.png',
      import.meta.url
    ),
  },
  {
    title: 'World vision',
    url: 'https://www.wvi.org/emergencies/ukraine',
    img1x: new URL(
      '../../images/support-ukraine/world-vision@1x.png',
      import.meta.url
    ),
    img2x: new URL(
      '../../images/support-ukraine/world-vision@2x.png',
      import.meta.url
    ),
  },
  {
    title: 'Serhiy Prytula Charity Foundation',
    url: 'https://prytulafoundation.org/en',
    img1x: new URL(
      '../../images/support-ukraine/prytula@1x.png',
      import.meta.url
    ),
    img2x: new URL(
      '../../images/support-ukraine/prytula@2x.png',
      import.meta.url
    ),
  },
];
